import type { ComponentType } from "react";
import type { SvgIconProps } from "@mui/material";
import {
  SpaceDashboardOutlined as DashboardIcon,
  ApartmentOutlined as PortalsIcon,
  PeopleAltOutlined as UsersIcon,
  SettingsOutlined as SettingsIcon,
} from "@mui/icons-material";
import { ROUTES } from "@/routes/config";

export interface NavItem {
  path: string;
  label: string;
  icon: ComponentType<SvgIconProps>;
}

const navItems: NavItem[] = [
  { path: ROUTES.DASHBOARD_HOME, label: "Dashboard", icon: DashboardIcon },
  { path: ROUTES.PORTALS, label: "Portals", icon: PortalsIcon },
  { path: ROUTES.USERS, label: "Users", icon: UsersIcon },
  { path: ROUTES.SYSTEM_SETTINGS, label: "Settings", icon: SettingsIcon },
];

export default navItems;
